import React, { ReactNode, useEffect } from 'react';
import { NextPage, NextPageContext } from 'next';
import App, { AppContext, AppProps } from 'next/app';
import { NextRouter, withRouter } from 'next/router';
import { observer } from 'mobx-react';
// import * as Sentry from '@sentry/browser';
import { configure } from 'mobx';

import { Provider, globalStore } from 'stores';
import * as _MM from 'lib';
import * as _MMCom from 'components';
import { ThemeProvider } from 'styled-components';

import { user, config, globalPageConfig } from 'lib';

import Modals from 'modules/layout/modals';
import LayoutBase from 'modules/layout/base';
import LayoutClient from 'modules/layout/client';
import LayoutEmtpy from 'modules/layout/empty';
import { GlobalStyle, ErrorBoundary } from '../components';
import theme from '../lib/theme';

import v1PublicStyle from 'lib/base-v1/styles/public.module.scss';
import v1WidgetStyle from 'lib/base-v1/widget/widget.module.scss';
import 'components/ui/icon/font/iconfont.css';
import 'components/ui/global-style/animate.css';
import 'components/ui/global-style/activity.css';
import 'overlayscrollbars/styles/overlayscrollbars.css';

const a = v1PublicStyle.a;
const b = v1WidgetStyle.b;

// import 'modules/room-v3/static/pc/styles/index.scss'
// import 'modules/room-v3/static/common/async/star.scss'
// import 'modules/room-v3/static/common/async/game.scss'
// import 'modules/room-v3/static/common/async/service.scss'

configure({
  isolateGlobalState: true,
});

// Sentry.init({
//   dsn: "https://d207042d52ec420292e88cea34f5c186@sentry.memeyule.com/7",
//   debug: !config.production,
//   release: config.version,
//   environment: config.mode,
//   sampleRate: 1,
//   whitelistUrls: [
//     /^http(s)?:\/\/.*.(2339|memeyule|sumeme).com/
//   ],
//   beforeSend: function (event, hint) {
//     // log('beforeSend', event, hint)
//     var error = hint!.originalException;
//     if (error) {
//       // @ts-ignore
//       if (error.message) {
//         // @ts-ignore
//         if (error.message.match(/NotSupportedError|MyAppGet/i)) {
//           return null;
//         }
//       }
//       // @ts-ignore
//       if (error.name) {
//         // @ts-ignore
//         if (error.name.match(/NotSupportedError/i)) {
//           return null;
//         }
//       }
//
//     }
//
//     return event;
//   },
// });

type Props = {
  // 页面属性
  pageProps: {
    // 布局
    layout: 'base' | 'empty' | 'client';
  };
} & AppProps;

const RootState = withRouter((props: { router: NextRouter; layout: string }) => {
  useEffect(() => {
    Object.assign(window, {
      _MM,
      _MMCom,
    });

    const { query, pathname } = props.router;
    const { layout } = props;

    // 确保这个变量第一时间更新
    if (layout === 'client') {
      window.inPcClient = true;
    }

    globalPageConfig.init();
    user.init(query);
  }, []);

  return null;
});

class MyApp extends App<Props> {
  // static getServerSideProps = () => {
  //   console.log('_app getServerSideProps')
  //   return {}
  // }

  // static getServerSideProps = async (appContext: AppContext) => {
  //
  //   console.log('getServerSideProps', appContext)
  //   const appProps = await App.getInitialProps(appContext);
  //   let locals = {};
  //   if (appContext.ctx && appContext.ctx.req) {
  //     locals = (appContext.ctx.req as any).locals;
  //   }
  //
  //   return {...appProps, locals, serverTime: Date.now()}//...appContext
  // }

  render() {
    const { Component, pageProps } = this.props;
    const { layout = 'base' } = pageProps;

    // console.log('pageProps===>', pageProps)

    const renderChild = () => {
      switch (layout) {
        case 'base':
          return (
            <LayoutBase {...pageProps}>
              <Component {...pageProps} />
            </LayoutBase>
          );
        case 'empty':
          return (
            <LayoutEmtpy {...pageProps}>
              <Component {...pageProps} />
            </LayoutEmtpy>
          );
        case 'client':
          return (
            <LayoutClient {...pageProps}>
              <Component {...pageProps} />
            </LayoutClient>
          );
        default:
          return <Component {...pageProps} />;
      }
    };
    // return renderChild()

    return (
      <ErrorBoundary from="app">
        <Provider value={globalStore}>
          <ThemeProvider theme={theme}>
            {layout && <GlobalStyle />}
            {layout && <RootState layout={layout} />}
            {renderChild()}
            {layout && <Modals />}
          </ThemeProvider>
        </Provider>
      </ErrorBoundary>
    );
  }
}

// 为了开启 next.config.js publicRuntimeConfig
MyApp.getInitialProps = (appContext: AppContext) => {
  return App.getInitialProps(appContext);
};

export default MyApp;
